export type ScreenSize = {
    name: string;
    minWidth: number;
    maxWidth?: number;
};

export const SCREEN_SIZES = {
    mobile: { minWidth: 0, maxWidth: 767 },
    tablet: { minWidth: 768, maxWidth: 1279 },
    desktop: { minWidth: 1280 },
} as const;

export type ScreenSizeName = keyof typeof SCREEN_SIZES;
